<template>
  <component :is="dialogContent" :parent-data="parentData"/>
</template>

<script>
import SickPay from "@/views/applications/salary/SickPay.vue";
export default {
  name: "SalaryItem",
  inject: ['$fn'],
  components: {
    SickPay
  },
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath: false,
        value: 'type',
        label: 'name'
      },
      loading: false,
      securityTempData: {},
      socialSecurityAreaList: [],
    }
  },
  methods: {},
  computed: {
    dialogContent() {
      switch (this.parentData.name) {
        case '病假工资':
          return SickPay;
        default:
          return SickPay;
      }
    },
  },
}
</script>

<style scoped lang="less">

</style>